import CompanyApprovalContextProvider from "../../tools/contexts/companyApproval/CompanyApprovalContext";
import CompanyApprovalContent from "../../components/companyApproval/CompanyApprovalContent";



const CompanyApproval=()=>{
    return   <CompanyApprovalContextProvider>
                <CompanyApprovalContent/>
             </CompanyApprovalContextProvider>
}
export default CompanyApproval;